<template>
  <section
    v-if="status === 'success'"
    class="airport"
  >
    <SectionTitle title="空港の天気" />
    <div class="table">
      <div class="head">
        <div class="block" />
        <template
          v-for="item in pointIdList.concat(jpAirports)"
          :key="item"
        >
          <div
            class="block"
            :class="item === jpAirports[0] ? 'jp' : ''"
          >
            <NuxtLink
              :external="isExternalLink || jpAirports.includes(item)"
              :to="jpAirports.includes(item) ? `https://weathernews.jp/onebox/tenki/spot/${data.info[item].spot_id}` : isExternalLink ? `${runtimeConfig.app.baseURL}${item.replace(/^\//, '')}` : item"
            >
              {{ data.info[item].point_ja }}
            </NuxtLink>
          </div>
        </template>
      </div>
      <div class="body">
        <div
          v-for="(day, idx) in data.wx.weekList"
          :key="day.date"
          class="column"
        >
          <div class="block">
            <p :class="day.dowEn">
              {{ day.date }}<span>({{ day.dowJa }})</span>
            </p>
          </div>
          <div
            v-for="item in pointIdList.concat(jpAirports)"
            :key="item"
            class="block"
            :class="item === jpAirports[0] ? 'jp' : ''"
          >
            <figure class="weather">
              <img
                :src="'https://gvs.weathernews.jp/onebox/img/wxicon/' + data.wx.dailyData[item][idx].wx + '.webp'"
                width="52"
                height="38"
                loading="lazy"
                alt=""
              >
            </figure>
            <div class="temp">
              <p class="high">
                {{ data.wx.dailyData[item][idx].maxt }}
              </p><p>/</p><p class="low">
                {{ data.wx.dailyData[item][idx].mint }}
              </p>
            </div>
            <!-- <div class="wind">
              <figure>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="11"
                  height="15"
                  viewBox="0 0 11 15"
                  :data-rank="wxData.dailyData[item][idx].wrank"
                  :style="`transform: rotate(calc(1deg * ${wxData.dailyData[item][idx].wdir_360 === null ? 0 : wxData.dailyData[item][idx].wdir_360}))`"
                >
                  <path
                    d="M9.91706 1.33286L5.48529 13.7418L1.05353 1.33286L5.31805 5.17093L5.48529 5.32145L5.65253 5.17093L9.91706 1.33286Z"
                    stroke="#333333"
                    stroke-width="0.5"
                  />
                </svg>
              </figure>
              <p>{{ wxData.dailyData[item][idx].wspd }}<span>m</span></p>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
const props = defineProps({
  pointIdList: {
    type: Array,
    default: () => []
  },
  now: {
    type: Number,
    required: true
  }
})

const jpAirports = ['hnd', 'nrt', 'kix']

const { data, status } = await useAsyncData(
  `pointAirportWxTable:${props.pointIdList.join(',')}`,
  async () => {
    const infoDataTask = props.pointIdList.length > 0 ? $fetch(`/api/point/info?pointId=${props.pointIdList.join(',')}`) : {}
    const ss1InfoDataTask = $fetch(`/api/ss1/info?pointId=${jpAirports.join(',')}`)

    const wxDataTask = props.pointIdList.length > 0 ? $fetch(`/api/point/weather?pointId=${props.pointIdList.join(',')}`) : {}
    const ss1WxDataTask = $fetch(`/api/ss1/weather?pointId=${jpAirports.join(',')}`)

    const results = await Promise.all([infoDataTask, ss1InfoDataTask, wxDataTask, ss1WxDataTask])
    const mrf = Object.assign(results[2], results[3])
    const wx = formatAirportWeather(props.pointIdList.concat(jpAirports), mrf, props.now)

    return {
      info: Object.assign(results[0], results[1]),
      wx
    }
  }
)

const runtimeConfig = useRuntimeConfig()
const { $isWebViewFlag: isWebViewFlag } = useNuxtApp()
const isExternalLink = ref(isWebViewFlag)
</script>

<style lang="scss" scoped>
.airport {
  display: flex;
  flex-direction: column;
  gap: 10px;
  .table {
    display: flex;
    width: 100%;
    .head {
      display: flex;
      flex-direction: column;
      width: 90px;
      padding-bottom: 4px;
      .block {
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #fafcfe;
        &:first-child {
          height: 30px;
        }
        &:not(:first-child) {
          height: 87px;
        }
        &.jp:not(:last-child) {
          border-top: solid 1px #b4becd;
        }
      }
      a {
        white-space: pre-wrap;
        color: #3569C0;
        text-align: center;
        font-size: 14px;
        font-weight: 600;
        line-height: 18px;
        text-decoration: underline;
      }
    }
    .body {
      display: flex;
      flex: 1;
      overflow-x: scroll;
      &::-webkit-scrollbar {
        width: 4px;
        height: 4px;
      }
      &::-webkit-scrollbar-track {
        border-radius: 4px;
        background-color: transparent;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 4px;
        background-color: #438fec;
      }
      .column {
        width: 64px;
      }
      .block {
        display: flex;
        align-items: center;
        justify-content: center;
        &:first-child {
          height: 30px;
          background-color: #f0f3f6;
          p {
            color: #303030;
            font-size: 15px;
            font-weight: 600;
            line-height: 23px;
            &.sat {
              color: #0060FF;
            }
            &.sun {
              color: #FF3000;
            }
          }
          span {
            font-size: 11px;
          }
        }
        &:not(:first-child) {
          flex-direction: column;
          height: 87px;
          padding: 6px;
        }
        &:nth-child(2n + 3) {
          background-color: #f0f3f6;
        }
        &.jp:not(:last-child) {
          border-top: solid 1px #b4becd;
        }
      }
      .weather {
        width: 52px;
      }
      .temp {
        display: flex;
        align-items: center;
        gap: 2px;
        p {
          font-family: "Hiragino Sans";
          color: #808080;
          font-size: 13px;
          font-weight: 600;
          line-height: 18px;
        }
        .high {
          color: #F64D00;
        }
        .low {
          color: #0075F3;
        }
      }
      .wind {
        display: flex;
        align-items: center;
        gap: 3px;
        figure {
          margin-top: -6px;
          svg {
              &[data-rank='0'] {
              fill: #ffffff;
              }
              &[data-rank='1'] {
                fill: #03aeef;
              }
              &[data-rank='2'] {
                fill: #05ad50;
              }
              &[data-rank='3'] {
                fill: #febf00;
              }
              &[data-rank='4'] {
                fill: #e86200;
              }
              &[data-rank='5'] {
                fill: #fe0000;
              }
            }
        }

        p {
          font-family: "Hiragino Sans";
          color: #303030;
          font-size: 13px;
          font-weight: 600;
          line-height: 18px;
        }
        span {
          font-size: 10px;
        }
      }
    }
  }
}
</style>
